module.exports = __webpack_public_path__ + "img/sd-logo.ae9c33b8.png";